import React, { useEffect, useState } from "react";
import AdminLayout from "../../masterLayout/AdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import { clearAdminSession, setAdminSession } from "../../auth/session";
import { adminApi, handleAdminLogoutIfNeeded } from "../../utils/adminApi";

const AdminProfile = () => {
  const [form, setForm] = useState({ email: "", newpass: "" });
  const [msg, setMsg] = useState("");

  useEffect(() => {
    document.title = "Admin Profile";
    (async () => {
      const res = await adminApi({ url: "admin/get-admin", method: "GET" });
      if (handleAdminLogoutIfNeeded(res)) return;
      if (res.success && res.data) {
        setForm({ email: res.data.email || "", newpass: "" });
        setAdminSession({
          uid: res.data.uid,
          admin: {
            uid: res.data.uid,
            email: res.data.email,
            role: "admin",
          },
        });
      }
    })().catch(console.error);
  }, []);

  const save = async (e) => {
    e.preventDefault();
    const res = await adminApi({
      url: "admin/update-admin",
      method: "POST",
      body: {
        email: form.email,
        ...(form.newpass ? { newpass: form.newpass } : {}),
      },
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Updated" : "Failed"));
    if (res.success && form.newpass) {
      setTimeout(() => {
        clearAdminSession();
        window.location.href = "/admin/login";
      }, 1200);
    }
  };

  return (
    <AdminLayout>
      <div className="admin-ui">
        <AdminPageHeader
          title="Admin profile"
          subtitle="Update the admin login email or set a new password."
        />
        {msg ? <div className="admin-alert admin-alert-info">{msg}</div> : null}
        <div className="admin-form-card" style={{ maxWidth: 520 }}>
          <div className="admin-form-head">
            <h6>Account</h6>
            <p>Changing password signs you out after save.</p>
          </div>
          <form onSubmit={save}>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
              </div>
              <div className="col-12">
                <label className="form-label">New password</label>
                <input
                  type="password"
                  className="form-control"
                  value={form.newpass}
                  onChange={(e) => setForm({ ...form, newpass: e.target.value })}
                  placeholder="Leave blank to keep current"
                />
              </div>
            </div>
            <div className="admin-form-actions" style={{ marginTop: 16 }}>
              <button type="submit" className="admin-btn admin-btn-primary">
                Update admin
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminProfile;
